const search = `
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <title>search-normal-c</title>
    <g class="icon-color" id="Symbols" transform="translate(24, 0) scale(-1, 1)">
      <g id="icn_search-normal" data-name="icn/search-normal">
        <path
          id="search"
          d="M6.79,9.74A7.34,7.34,0,1,1,14.13,17,7.31,7.31,0,0,1,6.79,
          9.74Zm-2.54,0a9.6,9.6,0,0,0,2.09,6L0.41,21.63a1.36,1.36,0,0,0,0,
          2,1.45,1.45,0,0,0,2,0l6-5.93A9.89,9.89,0,0,0,24,9.74,9.88,9.88,0,0,
          0,4.25,9.74Z"
          transform="translate(0)"
        />
      </g>
    </g>
  </svg>
`

export default search
